import React, { useState } from 'react';
import {
    Navbar,
    NavbarBrand,
    NavbarToggler,
    Collapse,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import LogoSistema from '../../components/LogoSistema/LogoSistema';

const Navigation = () => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    const path = location.pathname.replace(/\/$/, "").toLowerCase();

    return (
        <Navbar expand="lg" className="menu">
            <div className='navigation-menu d-flex justify-content-between align-items-center px-2 w-100'>
                <NavbarToggler onClick={toggle}>
                    <span className="navbar-toggler-bar navbar-hamburg"></span>
                    <span className="navbar-toggler-bar navbar-hamburg"></span>
                    <span className="navbar-toggler-bar navbar-hamburg"></span>
                </NavbarToggler>
                <NavbarBrand>
                    <LogoSistema identificacaoLogo={"logotipoBranco"} style={{ maxHeight: '70px' }} />
                    <LogoSistema identificacaoLogo={"logoSecretariaBranco"} className='logoSecretariaNavigation'  style={{ maxHeight:'60px' }} />
                </NavbarBrand>
                <span
                    className='titleNavigation p-2'
                    style={{ color: "white", marginTop: "4px", borderLeft: "3px solid white" }}>
                    GESTÃO RESÍDUOS SÓLIDOS ESPECIAIS
                </span>

                <Collapse className={`justify-content-end align-items-center ${isOpen ? "hideCollapse" : "d-flex"}`}>
                    <Nav className="justify-content-center" navbar>
                        <NavItem>
                            <NavLink href="/auth/Opcoes">
                                Novo Cadastro
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="/auth/MeuCadastro">
                                Meu Cadastro
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
                {path !== "/auth/duvidas" &&
                    <Link
                        to="/auth/duvidas"
                        className='navigationDuvidas d-flex justify-content-center align-items-center'
                    >
                        Dúvidas
                    </Link>
                }
            </div>
        </Navbar>
    );
};
export default Navigation;
